import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class KnowledgeTitle extends PrimitiveValueObject<string> {
  static create(value: string): KnowledgeTitle {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeTitle(value);
  }
}
